import { Component, inject, Input } from '@angular/core';
import { ApiArticle, ApiFranchise, ArticlesApi } from '@tytapp/api';
import { FollowButton, HomeCard, HomeCardComponentType, HomeCardIcon, HomeCardLink } from '@tytapp/app/pages/home-page/home-cards.service';
import { LoggerService } from '@tytapp/common';
import { ArticlesService, FranchisesService } from '@tytapp/common-ui';

@Component({
    selector: 'tyt-article-card',
    templateUrl: './article-card.component.html',
    styleUrls: ['./article-card.component.scss']
})
export class ArticleCardComponent implements HomeCardComponentType {
    private logger = inject(LoggerService);
    private readonly articlesService = inject(ArticlesService);
    private readonly franchisesService = inject(FranchisesService);
    private readonly articlesApi = inject(ArticlesApi);

    @Input() showFranchises = false;

    card: HomeCard;
    franchiseSlug: string;
    title: string = 'Article';
    icon?: HomeCardIcon;
    state: 'loading' | 'ready' = 'loading';
    franchise: ApiFranchise;
    articles: ApiArticle[];
    mode: 'latest' | 'featured' = 'latest';
    count = 1;
    allFranchises: ApiFranchise[] = [];
    moreFranchises: ApiFranchise[] = [];

    get more() {
        let folder = `/${this.franchise?.show_in_original_reporting ? 'reports' : 'stories'}`;

        if (this.mode === 'featured')
            return { url: folder }

        return { url: `${folder}/${this.franchiseSlug}` };
    }

    get hidden() { return this.state === 'ready' && (this.articles?.length === 0 || !this.franchise); }

    async ngOnInit() {
        try {
            if (this.mode === 'latest') {
                await Promise.all([
                    this.franchisesService.get(this.franchiseSlug).then(f => this.franchise = f),
                    this.articlesService.franchiseFeed(this.franchiseSlug, 0, this.count).then(articles => this.articles = articles),
                    this.franchisesService.all().then(fs => this.allFranchises = fs)
                ]);

            } else {
                let article = await this.articlesApi.getFeaturedArticle().toPromise();
                this.franchise = article.franchise;
                this.articles = [ article ];
            }

            if (this.franchise) {
                this.moreFranchises = this.allFranchises
                    .filter(x => x.show_in_original_reporting === this.franchise.show_in_original_reporting)
                    .filter(x => x.id !== this.franchise.id)
                ;
            } else {
                this.moreFranchises = [];
            }
        } catch (e) {
            this.logger.error(`Failed to fetch article information for Article module:`);
            this.logger.error(e);
        }

        this.state = 'ready';
    }

    articleUrlFor(article: ApiArticle) {
        return this.articlesService.getArticleUrlSync(article);
    }
}
